import React, {useState, useEffect} from 'react'
// Styles
import './lgdest.style.css';
// Constant
import { Base_API } from '../../_actions/matcher'
import { NhealthAction } from '../../_actions/action.api'
import liff from '@line/liff'
import { DecryptedOBJ, EncryptedOBJ } from '../../utils/Encryption';
import useLineLogin from '../../_actions/authLine/lineLogin';
import lineConfig from '../../_actions/authLine/lineConfig';

function Login_Destination() {
    
    useEffect(() => {
        dataInit();
    })

    const dataInit = async() => {
        await useLineLogin(lineConfig.login_destination);
        await getMemberInit();
    }

    const getMemberInit = () => {
        // console.log('Get Member Init');
        let lineUser = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile'))["user_id"] : null;
        return new Promise(async resolve => {
            NhealthAction.GetMember(lineUser)
            .then(res => {
                if(res.isSuccess === true)
                {
                    let memberInfo = EncryptedOBJ(res.member);
                    localStorage.setItem('member_info', memberInfo);
                    window.location.href = `${Base_API.pathWeb}/n-health/mycard`
                }else
                {
                    window.location.href = `${Base_API.pathWeb}/n-health/mycard`
                }
                // console.log(res);
            })
            resolve();
        })
    }

    return (
        <div>

        </div>
    )
}

export default Login_Destination